import { component } from 'picoapp';
import jump from 'jump.js';

function BrandsNav(node, ctx) {
  const filter_els = node.querySelectorAll("[data-filter]")
  const vendor_els = node.querySelectorAll("[data-group]")

  const scrollToElement = filter => {
    const vendor = Array.from(vendor_els).find((v) => v.dataset.group == filter);

    jump(vendor, {
      duration: 100,
      offset: -50
    })

    vendor.classList.add('filtered');
    Array.from(vendor_els).filter((i) => i != vendor).forEach((el) => el.classList.remove("filtered"))
  }

  for (let filter_el of filter_els) {
    filter_el.addEventListener('click', () => {
      filter_el.classList.add('is-active');
      Array.from(filter_els).filter((i) => i != filter_el).forEach((el) => el.classList.remove("is-active"))
      scrollToElement(filter_el.dataset.filter);
    })
  }
}

export default component((node, ctx) => {
  new BrandsNav(node, ctx);
});
